import React from 'react';
import styled from 'styled-components';
import {DividerColor, HoverColor, OnSurface} from '../../Colors';

const style = {
	ListItem : styled.li`
        padding-bottom : 0.5rem;
        padding-left : 0.5rem;
        padding-right : 0.5rem;
        cursor : pointer;
        width : 100%;
        max-width: 100%;
        color : ${OnSurface};
		border-radius: 0;
        background-color: transparent;
		&:hover{
            background-color: ${HoverColor};
        }
        list-style-type: none;
    `,
	ListItemSpan : styled.span`
        padding-bottom : 0.5rem;
        padding-left : 0.5rem;
        padding-right : 0.5rem;
        cursor : pointer;
        width : 100%;
        max-width: 100%;
        color : ${OnSurface};
		border-radius: 0;
        background-color: transparent;
		&:hover{
            background-color: ${HoverColor};
        }
        list-style-type: none;
    `,
};


const ListItem = ({...props}) =>
	<style.ListItem {...props}/>;

export const ListItemWithSpan = ({...props}) =>{
	return <style.ListItemSpan {...props}/>;
};
export const UnderlinedList = styled(ListItem)`
    border-bottom: 1px solid ${DividerColor};
`;

export const UnderlinedListWithSpan = styled(ListItemWithSpan)`
border-bottom: 1px solid ${DividerColor};
`;

export default ListItem;